import React from 'react';
import styled from 'styled-components';

import MujerCielo from '../img/rszmujercielo.jpg';
import MujerLlorando from '../img/rszmujerllorando.jpg';
import Camino from '.././img/rszLuzCamino.jpg';
import Anciano from '../img/rszanciano.jpg';
import SeaOfclouds from '../img/rszseaofclouds.jpg';
import NinoGlobo from '../img/rszninoglobo.jpg';

const Inicio = () => {
    return (
        <div>
            <HEADER>
                <h1>Tanatología</h1>
            </HEADER>
            <Contenedor>
                <p>La Tanatología es una disciplina científica que se encarga de encontrar el sentido al proceso de la muerte, sus ritos y significado concebido como disciplina profesional, que integra a la persona como un ser biológico, psicológico, social y espiritual para vivir en plenitud y buscar su transcendencia.
                También se encarga de los duelos derivados de pérdidas significativas que no tengan que ver con la muerte física o enfermos terminales.
                <br></br>
                <ImgMujerLlorando src={MujerLlorando}/>
                </p>
                                
                <ImgMujerCielo src={MujerCielo}/>
            </Contenedor>            

            <DIV>
                <p>"Sabemos lo dificil que es decirle adios a un ser querido y estamos preparados para brindarte la ayuda que necesitas".</p>                
                <ImgNinoGlobo src={NinoGlobo} />
                <ImgSeaOfclouds src={SeaOfclouds} />                
                <br />
            </DIV>
            
            <HEADER>
                <h1>Cuidados Paliativos</h1>
            </HEADER>
            <Contenedor2> 
                    <ImgAnciano src={Anciano} />
                    
                    <p>Los Cuidados Paliativos son la especialidad médica que centra su atención en los enfermos terminales, es decir, aquellos cuya expectativa de vida es relativamente corta por causa de una enfermedad que no responde a los tratamientos curativos.
                        <br />
                        <br />                    
                        <UL>
                            <p>TANCU ofrece los siguientes servicios para nuestros seres queridos son:</p>
                            <br />
                                <LI>
                                    <li>Evaluaciones Geriátricas</li>
                                    <li>Depresión y Ansiedad</li>
                                    <li>Apoyo Familiar</li>
                                    <li>Apoyo al Cuidador Primario</li>
                                    <li>Terapia Funcional</li>
                                    <li>Valoración de Barreras Físicas</li>
                                    <li>Polifarmacia</li>
                                    <li>Valoración Dietética</li>
                                    <li>Acompañamiento Emocional</li>
                                    <li>Talleres para Cuidadoras</li>
                                    {/* <li>Evaluación de barreras y estructuras.</li>
                                    <li>Depresión y transtorno de la marcha.</li>
                                    <li>Apoyo a la familia.</li>
                                    <li>Terapia funcional.</li>
                                    <li>Valoración dietética.</li>
                                    <li>Revisión de medicamentos.</li> */}
                                </LI>
                        </UL>
                    </p>
                
                
            </Contenedor2>
            
            <DIV>
                <p>"Te ayudamos a encontrar una luz al final".</p>
                <br />
                    <ImgCamino src={Camino} />    
                
            </DIV>

            <HEADER>
                <h1>Nuestros profesionales</h1>
            </HEADER>
                
            <DIV>
                <p>Licenciada en Enfermería y Psicología con especialidad en Tanatología y Cuidados Paliativos Maria Elena Rodriguez Díaz.</p>
                <br />
                <p>Administrador y desarrollador del portal Licenciado en Infomática Ernesto Figueroa Cervantes</p>
            </DIV>
                
            

            <HEADER>
                <h1>Contacto</h1>
            </HEADER>
            
            <DIV>
                <p>Correo: maelena.roddiaz@gmail.com ó efigueroa83@hotmail.com</p>
                <p>Telf: 55 2864 2053 y 55 3816 9042</p>
                <BUTTON>
                    <a href="https://www.facebook.com/TancuLiberandoEmociones/">
                        <button>facebook</button>
                    </a> 
                </BUTTON>
                
                
            </DIV>
                
            
        </div>        
        
    );
}
const HEADER = styled.div`
    width: 100%;
    margin: 2rem 0rem 1rem 2rem;
    text-decoration: underline #092c4c;

    @media (max-width: 420px) { 
        font-size: 12px;
      }
`
const Contenedor = styled.div`
    width: 90%;
    margin: 2rem 2rem 0rem 2rem;
    display: flex;
    font-size: 14px;
    text-align: justify;
`
const Contenedor2 = styled.div`
    width: 90%;
    margin: 2rem 2rem 0rem 2rem;
    display: flex;
    font-size: 14px;
    text-align: justify;

    @media (max-width: 420px) { 
        width: 95%;
        max-width: 420px;
        display: block;
        margin: 3rem 2rem 2rem 2rem;
      }
`
const ImgMujerCielo = styled.img`
    width: 32%;
    height: 360px;
    margin: 0rem 2rem 2rem 2rem;
    border-radius: 10px;
    @media (max-width: 950px) { 
        width: 0%;
        height: 0%;
        margin: 0rem;
        visibility: hidden;
      }
`
const ImgMujerLlorando= styled.img`
    width: 68%;
    max-width: 550px;
    height: 55%;
    aling-items: center;
    margin: 2rem 0rem 0rem 4rem;
    border-radius: 10px;

    @media (max-width: 950px) { 
        max-width: 400px;
      }

    @media (max-width: 530px) { 
        margin: 2rem 0rem 3rem 2rem;
      }
    @media (max-width: 420px) { 
        width: 68%;
        max-width: 410px;
        height: 25%;
    }
`
const ImgAnciano = styled.img`
    width: 25%;
    height: 70%;
    margin: .5rem 2rem 2rem 2rem;
    border-radius: 10px;
    @media (max-width: 820px) { 
        width: 0%;
        height: 0%;
        margin: 0rem;
        visibility: hidden;
      }
`
const ImgSeaOfclouds = styled.img`
    width: 40%;
    height: 50%;
    margin: 2rem 0rem 2rem 4rem;
    border-radius: 10px;
    @media (max-width: 680px) { 
        width: 0%;
        height: 0%;
        margin: 0rem;
        visibility: hidden;
      }
`
const ImgNinoGlobo = styled.img`
    width: 40%;
    height: 50%;
    margin: 2rem 2rem 2rem 2rem;
    border-radius: 10px;
    
    @media (max-width: 420px) { 
        width: 68%;
        max-width: 410px;
        height: 25%;
    }
`
const UL = styled.ul`
    width: 90%;
    margin: .2rem 5rem 0rem 3rem;
    padding: .1rem;
    color: #092c4c;
    background-color: #F4F3EE;
`
const LI = styled.li`
    margin: 0rem 5rem 0rem 1rem;
    color: #092c4c;
    background-color: #F4F3EE;
`
const DIV = styled.div`
    width: 95%;
    height: 100%;
    margin: 1rem 2rem 2rem 2rem;
    display: block;
    font-size: 14px;
    font-weight: bold;
    @media (max-width: 950px) { 
        margin: 0rem 2rem 2rem 2rem;
      }
`
const ImgCamino = styled.img`
    width: 75%;
    height: 55%;
    margin: 0rem 2rem 2rem 4rem;
    border-radius: 10px;
    display: block;
    
    
    @media (max-width: 420px) { 
        width: 65%;
        height: 55%;
      }
`
const BUTTON = styled.button`
    margin: 2rem 0rem;
    background-color: #3B5998;
    color: white;
    padding: 15px 15px;
    text-decoration: none;
    border-radius: 15%;
`
export default Inicio;